export const OFFER_BOX_WIDTH = 388

export const AP_DESKTOP_SMALL_COLUMN_MAX_WIDTH = 384
export const AP_DESKTOP_SMALL_COLUMN_MIN_WIDTH = 256
export const AP_DESKTOP_LARGE_COLUMN_WIDTH = 640
export const AP_DESKTOP_OVERLAY_LARGE_COLUMN_WIDTH = 488
